module.exports = __webpack_public_path__ + "static/media/wardah-inspiring-teacher.12ce7cf3.jpeg";